import { render } from "./PrivacyNew.vue?vue&type=template&id=3fe35905"
import script from "./PrivacyNew.vue?vue&type=script&lang=js"
export * from "./PrivacyNew.vue?vue&type=script&lang=js"

import "./PrivacyNew.vue?vue&type=style&index=0&id=3fe35905&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__